<div class="wrapper">
  <ifp-application-status-icon-chip [status]="application?.customerFacingStatus"></ifp-application-status-icon-chip>
</div>

